import { ArrowLeft, FileText, Loader2, Save } from "lucide-react"

import { Button } from "shared/ui/button"
import { Card, CardHeader, CardTitle } from "shared/ui/card"

type EditorHeaderCardProps = {
  onBack?: () => void
  onRun?: () => void
  onSave: () => void
  isSaving: boolean
  saveDisabled: boolean
}

export function EditorHeaderCard({
  onBack,
  onRun,
  onSave,
  isSaving,
  saveDisabled,
}: EditorHeaderCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div>
          <CardTitle className="text-xl">Dynamic Report Template Editor</CardTitle>
          <p className="text-sm text-gray-500">Configure fields and filters for selected report template</p>
        </div>
        <div className="flex items-center gap-2">
          {onBack ? (
            <Button variant="outline" className="gap-2" onClick={onBack}>
              <ArrowLeft className="h-4 w-4" />
              Back to Template List
            </Button>
          ) : null}
          {onRun ? (
            <Button variant="outline" className="gap-2" onClick={onRun}>
              <FileText className="h-4 w-4" />
              Preview / Run
            </Button>
          ) : null}
          <Button onClick={onSave} disabled={saveDisabled} className="gap-2">
            {isSaving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
            Save
          </Button>
        </div>
      </CardHeader>
    </Card>
  )
}

